const DEFAULT_VERSION = 'unknown';
const DEFAULT_MCS_RUN_ENV = 'local';
/**
 * Такое значение проставляется `@cian/frontend-builder`
 */
const DEV_MCS_RUN_ENV = 'DEV';
var McsRunEnvType;
(function (McsRunEnvType) {
    McsRunEnvType["Local"] = "local";
    McsRunEnvType["Dev"] = "dev";
    McsRunEnvType["Beta"] = "beta";
    McsRunEnvType["Prod"] = "prod";
    McsRunEnvType["Stage"] = "stage";
})(McsRunEnvType || (McsRunEnvType = {}));
const CLIENT_GLOBAL_OBJECT_KEY = 'globalObjectKey';
const CLIENT_APP_ENV_DUMP_KEY = '_cianAppEnv';
const CORE_APP_ENV_KEYS_ATTR_MAP = {
    application: 'application',
    version: 'version',
    mcsRunEnv: 'mcsrunenv',
    versionCommit: 'versioncommit',
};
const CORE_APP_ENV_KEYS_QUERY_MAP = {
    application: 'application',
    version: 'version',
    mcsRunEnv: 'mcsRunEnv',
    versionCommit: 'versionCommit',
};

export { CLIENT_APP_ENV_DUMP_KEY, CLIENT_GLOBAL_OBJECT_KEY, CORE_APP_ENV_KEYS_ATTR_MAP, CORE_APP_ENV_KEYS_QUERY_MAP, DEFAULT_MCS_RUN_ENV, DEFAULT_VERSION, DEV_MCS_RUN_ENV, McsRunEnvType };
//# sourceMappingURL=const.js.map
